import type { JSX } from 'react'

import { DEFAULT_PY_QUARTER_POLICIES } from '../../../model/constants'
import type { SobTableEntry } from '../../../model/types'
import type { SobActualsTableController } from '../../../model/useSobActualsModalContent'
import { SobActualsTable, type SobTableTitlePlacement } from '../sobActualsTable/SobActualsTable'

type SobActualsEntryTableProps = {
  entry: SobTableEntry
  controller: SobActualsTableController
  title?: string
  titlePlacement?: SobTableTitlePlacement
}

export const SobActualsEntryTable = ({
  entry,
  controller,
  title,
  titlePlacement,
}: SobActualsEntryTableProps): JSX.Element => {
  const entryInputs = controller.getEntryInputs(entry)
  const noPlanEligibility = controller.getNoPlanEligibility(entry, false)
  const noPlanContractualEligibility = controller.getNoPlanEligibility(entry, true)

  return (
    <SobActualsTable
      model={entry.model}
      showOverall={controller.showOverall}
      title={title}
      titlePlacement={titlePlacement}
      isNoPlan={controller.getEntryEffectiveNoPlan(entry)}
      noPlanToggleChecked={controller.getEntryNoPlan(entry)}
      isNoPlanContractual={controller.getEntryNoPlanContractual(entry)}
      showNoPlanToggle={noPlanEligibility.show}
      showNoPlanContractualToggle={noPlanContractualEligibility.show}
      noPlanToggleDisabled={noPlanEligibility.disabled}
      noPlanContractualToggleDisabled={noPlanContractualEligibility.disabled}
      currentActualsInput={entryInputs.prevActuals}
      actualsInput={entryInputs.currentActuals}
      planInput={entryInputs.currentPlan}
      currentActualsModifiedQuarters={controller.getEntryModifiedQuarters(entry, 'prevActuals')}
      actualsModifiedQuarters={controller.getEntryModifiedQuarters(entry, 'currentActuals')}
      previousYearQuarterPolicies={
        controller.previousYearQuarterPoliciesByKey[entry.key] ?? DEFAULT_PY_QUARTER_POLICIES
      }
      currentYearQuarterPolicies={
        controller.currentYearQuarterPoliciesByKey[entry.key] ??
        controller.currentYearQuarterPolicies
      }
      onNoPlanChange={controller.setEntryNoPlan(entry)}
      onNoPlanContractualChange={controller.setEntryNoPlanContractual(entry)}
      onCurrentActualsInputChange={controller.setEntryInputValues(entry, 'prevActuals')}
      onActualsInputChange={controller.setEntryInputValues(entry, 'currentActuals')}
      onPlanInputChange={controller.setEntryInputValues(entry, 'currentPlan')}
    />
  )
}
